import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { Navbar, Footer, Sidebar, ThemeSettings } from './Components';
import { Contact, Ecommerce, Orders, Calendar, Employees, Stacked, Pyramid, Customers, Kanban, Line, Area, Bar, Pie, Financial, ColorPicker, ColorMapping, Editor, Events, Faculty, Placement, Circular, Course, Gallery, Inquiry, Syllabus, Dashboard, Testimonial, Users, InquiryList, SanctionList, DisbursedList, RejectList, UserProfile } from './Pages';
import Login from './Pages/Login';
import './App.css';

import { useStateContext } from './Contexts/ContextProvider';
import { BaseUrlProvider } from './Contexts/BaseUrlContext';
import VideoUpload from './Pages/VideoUpload';
import VideoList from './Pages/VideoList';

// Protected Route component to check authentication
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('authToken');
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const App = () => {
  const { setCurrentColor, setCurrentMode, currentMode, activeMenu, currentColor, themeSettings, setThemeSettings } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <BrowserRouter>
        <BaseUrlProvider>
          <div className="flex relative dark:bg-main-dark-bg">
            <div className="fixed right-4 bottom-4" style={{ zIndex: '1000' }}>
              <TooltipComponent content="Settings" position="Top">
                <button
                  type="button"
                  onClick={() => setThemeSettings(true)}
                  style={{ background: currentColor, borderRadius: '50%' }}
                  className="text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
                >
                  <FiSettings />
                </button>
              </TooltipComponent>
            </div>
            <Routes>
              {/* Public Login Route */}
              <Route path="/login" element={<Login />} />

              {/* Protected Routes */}
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <div className="flex relative dark:bg-main-dark-bg" style={{ width: "100%" }}>
                      {activeMenu ? (
                        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
                          <Sidebar />
                        </div>
                      ) : (
                        <div className="w-0 dark:bg-secondary-dark-bg">
                          <Sidebar />
                        </div>
                      )}
                      <div
                        className={
                          activeMenu
                            ? 'dark:bg-main-dark-bg bg-main-bg min-h-screen md:ml-72 w-full'
                            : 'bg-main-bg dark:bg-main-dark-bg w-full min-h-screen flex-2'
                        }
                      >
                        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
                          <Navbar />
                        </div>
                        <div>
                          {themeSettings && <ThemeSettings />}
                          <Routes>
                            {/* Default Route Redirect */}
                            <Route
                              path="/"
                              element={<Navigate to="/dashboard" replace />}
                            />
                            {/* Dashboard */}
                            <Route
                              path="/dashboard"
                              element={<Dashboard />}
                            />
                         
                            <Route
                              path="/Inquiry_List"
                              element={<InquiryList />}
                            />
                            <Route path="/sanction-file" 
                            element={<SanctionList />} />
                            <Route
                              path="/disbursed-file"
                              element={<DisbursedList />}
                            />
                          <Route path="/reject-file"
                            element={<RejectList />}
                          />
                            <Route
                              path="/user/:id"
                              element={<UserProfile />} 
                            />
                          </Routes>
                        </div>
                        <Footer />
                      </div>
                    </div>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </BaseUrlProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;